import type { IconNode, LucideIcon } from 'lucide-react'
import { createLucideIcon } from 'lucide-react'

// The single-line Text Input field: Lucide's text-align-start cut to two lines, so it pairs
// with that glyph on the multiple-lines field and differs only by line count.
export const TEXT_SHORT_NODES: IconNode = [
  ['path', { key: 'text-short-0', d: 'M21 9H3' }],
  ['path', { key: 'text-short-1', d: 'M15 15H3' }],
]

export const TextShortIcon: LucideIcon = createLucideIcon(
  'text-short',
  TEXT_SHORT_NODES,
)
